import { ComboboxField } from '@ps-design-system/components/Combobox';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { fetchActivityTags } from '../../services/checkout-service';
import PropTypes from 'prop-types';

export const ActivityCombobox = injectIntl(
  ({ intl, name, ...props }) => {
    const [activityOptions, setActivityOptions] = React.useState([]);

    React.useEffect(() => {
      (async () => {
        const activityTags = await fetchActivityTags(intl.locale);
        setActivityOptions(
          activityTags.map((tag) => ({
            value: tag.toLowerCase(),
            label: `${tag.charAt(0).toUpperCase()}${tag.slice(1)}`
          }))
        );
      })();
    }, []);

    return (
      <ComboboxField
        testId="activity-combobox"
        name={name}
        options={activityOptions}
        label="What are you planning?"
        triggerProps={{
          placeholder: (
            <FormattedMessage
              id="activity_combobox.placeholder"
              defaultMessage="e.g. Photo shoot, Video shoot"
            />
          )
        }}
        {...props}
      />
    );
  }
);

ActivityCombobox.displayName = 'ActivityCombobox';
ActivityCombobox.propTypes = {
  name: PropTypes.string.isRequired
};
